import { atom } from 'jotai';

export type ModalInformationAtom =
  | null
  | {
      type: 'UNITEDMEMBER_JOIN';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'BIZMEMBER_JOIN';
      handleClickLeftBtn: () => void;
      handleClickRightBtn: () => void;
    }
  | {
      type: 'SENDEMAIL_CODE_CONFIRM';
      handleClickRightBtn: () => void;
    }
  | {
      type: 'SENDEMAIL_CODE_ALERT';
    }
  | {
      type: 'SENDEMAIL_CODE_ERROR';
    }
  | {
      type: 'NOSENDEMAIL_CODE';
    }
  | {
      type: 'EMAIL_CHECK';
    }
  | {
      type: 'ACCOUNT_UNLINK';
      handleClickRightBtn: () => void;
    }
  | {
      type: 'ACCOUNT_LINK';
      handleClickRightBtn: () => void;
    }
  | {
      type: 'MEMBERSHIP_UNSUBSCRIBE';
      handleClickRightBtn: () => void;
    }
  | {
      type: 'ACCOUNT_LINK_REQUEST';
      handleClickRightBtn: () => void;
    }
  | {
      type: 'TERMS_ERROR';
    }
  | {
      type: 'STEP3_BIZNAME_ERROR';
    }
  | {
      type: 'STEP3_BIZLICENSE_ERROR';
    }
  | {
      type: 'STEP3_BIZADDREDD_ERROR';
    }
  | {
      type: 'CARD_CHECK';
    }
  | {
      type: 'ITEM_ERROR';
      item: string;
    }
  | {
      type: 'WARNING_AND_NEXT';
      message: string;
      handleClickRightBtn: () => void;
    }
  | {
      type: 'CONFIRM';
      message: string;
      powerOK?: boolean;
      handleClickRightBtn: () => void;
    }
  | {
      type: 'ITEM_COMPLETE_ERROR';
      item: string;
    }
  | {
      type: 'WARNING';
      message: string;
    }
  | {
      type: 'FILE_ERROR';
    }
  | {
      type: 'CHECK_FREE';
    }
  | {
      type: 'SUBSCRIBE_FREE';
      handleClickRightBtn: () => void;
    }
  | {
      type: 'JOIN_CONFIRM';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'JOIN_ERROR';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'WITHDRAW_MEMBER';
    }
  | {
      type: 'REMOVE_CART';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'API_ERROR';
      message: string;
    }
  | {
      type: 'NOT_OPEN';
    }
  | {
      type: 'AGREE_CHECK';
    }
  | {
      type: 'LOGIN_CONFIRM';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'CHOICE_CATEGORY';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'MEMBERSHIP_SUBSCRIBE';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'CHANGE_CARD';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'PAY_SUCCESS';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'CHANGE_SUCCESS';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'UNSUBSCRIBE_SUCCESS';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'PAY_CANCEL';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'DELETE_MEMBERSHIP';
      handleClickRightBtn?: () => void;
    }
  | {
      type: 'CHECK_MEMBERSHIP';
      handleClickRightBtn?: () => void;
    };

export type AllModalTypes = Exclude<ModalInformationAtom, null>['type'];

const modalInformationAtom = atom<ModalInformationAtom>(null);

export default modalInformationAtom;
